import { render, staticRenderFns } from "./Logistics.vue?vue&type=template&id=10b13abc&scoped=true&"
import script from "./Logistics.vue?vue&type=script&lang=js&"
export * from "./Logistics.vue?vue&type=script&lang=js&"
import style0 from "./Logistics.vue?vue&type=style&index=0&id=10b13abc&lang=scss&scoped=true&"
import style1 from "./Logistics.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b13abc",
  null
  
)

export default component.exports